import { render, staticRenderFns } from "./IconExclamationOutline.vue?vue&type=template&id=7c5f1c22"
import script from "./IconExclamationOutline.vue?vue&type=script&lang=js"
export * from "./IconExclamationOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports